import { ACTIVE_SEASON_ALERT_SET_IGNORE } from './constants';
import {
    SetActiveSeasonAlertIgnoreAction,
    ActiveSeasonAlertIgnore
} from './types';

export const setActiveSeasonAlertIgnore = (
    ignore: ActiveSeasonAlertIgnore
): SetActiveSeasonAlertIgnoreAction => ({
    type: ACTIVE_SEASON_ALERT_SET_IGNORE,
    payload: ignore
});
